// extracted by mini-css-extract-plugin
export default {"tableCustom":"tableCustom_tableCustom__16qCe"};